type ApiErrorLike = {
  response?: {
    data?: {
      detail?: unknown
    }
  }
}

export function getApiErrorDetail(error: unknown): string | undefined {
  const detail = (error as ApiErrorLike)?.response?.data?.detail
  return typeof detail === 'string' ? detail : undefined
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  return getApiErrorDetail(error) || (error instanceof Error ? error.message : fallback)
}
